import { useNavigate } from 'react-router-dom';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { UserX, ArrowLeft } from 'lucide-react';

interface NotFoundProps {
  error?: string | null;
}

export function NotFound({ error }: NotFoundProps) {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50 py-6 px-4">
      <div className="max-w-7xl mx-auto space-y-6">
        <Button
          variant="ghost"
          className="flex items-center gap-2 hover:bg-gray-100"
          onClick={() => navigate('/dashboard')}
        >
          <ArrowLeft className="h-4 w-4" />
          Voltar para Dashboard
        </Button>

        <Card className="p-8 flex flex-col items-center justify-center text-center">
          <UserX className="h-16 w-16 text-gray-400 mb-4" />
          <h1 className="text-2xl font-bold text-gray-900 mb-2">
            {error || 'Prestador não encontrado'}
          </h1>
          <p className="text-gray-600 mb-6 max-w-md">
            {error 
              ? 'Ocorreu um erro ao carregar as informações. Por favor, tente novamente mais tarde.'
              : 'O prestador de serviços que você está procurando não foi encontrado ou não está mais disponível.'}
          </p>
          <Button onClick={() => navigate('/dashboard')}>
            Voltar para Dashboard
          </Button>
        </Card>
      </div>
    </div>
  );
}